export const API_URL =
  process.env.USE_LOAD_BALANCER_API === 'true'
    ? `${window.location.origin}/api`
    : process.env.API_SERVICE_URL;
